import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

import GatewayHomeTemplate from 'text!../views/gateway-home.html';
import NewQuoteAccountSearchTemplate from 'text!../views/new-quote-account-search.html';
import NewQuoteTemplate from 'text!../views/new-quote.html';
import AccountDetailTemplate from 'text!../views/account-detail.html';
import PolicyChangeTemplate from 'text!../views/policy/policy-change.html';
import PreemptionTemplate from 'text!../views/policy/preemption.html';
import SearchTemplate from 'text!../views/search.html';
import PolicyDetailTemplate from 'text!../views/policy-detail.html';
import QuoteDetailTemplate from 'text!../views/quote-detail.html';
import RenewalDetailTemplate from 'text!../views/renewal-detail.html';
import EndorsementDetailTemplate from 'text!../views/endorsement-detail.html';
import CancellationDetailTemplate from 'text!../views/cancellation-detail.html';
import AccountLandingTemplate from 'text!../views/account-landing.html';
import AccountSummaryTemplate from 'text!../views/account/account-summary.html';
import ClaimsLandingTemplate from 'has-text?financials!../views/claims-landing.html';
import InvoicePaymentTemplate from 'text!edge/billing/views/invoice-payment.html';
import AccountActivitiesTemplate from 'text!../views/account/activities.html';
import AccountQuotesTemplate from 'text!../views/account/quotes.html';
import AccountClaimsTemplate from 'text!../views/account/claims.html';
import AccountContactsParentTemplate from 'text!../contacts/common/views/account-contacts-parent.html';
import AccountContactsTemplate from 'text!../contacts/common/views/account-contact-summary.html';
import RelatedAccountContactsTemplate from 'text!../contacts/common/views/related-account-contacts.html';
import AccountContactDetailTemplate from 'text!../contacts/common/views/account-contact-detail.html';
import AccountPolicyTransactionsTemplate from 'text!../views/account/policy-transactions.html';
import AccountNotesTemplate from 'text!../views/account/notes.html';
import AccountDocumentsTemplate from 'text!../views/account/documents.html';
import AccountBillingTemplate from 'text!../views/account/billing.html';
import JourneyPageTemplate from 'text!conditional?if=journey&equals=true!../journey/gateway-journey-page.html';
import PolicyLandingTemplate from 'text!../views/policy-landing.html';
import PolicySummaryTemplate from 'text!../views/policy/policy-summary.html';
import PolicyActivitiesTemplate from 'text!../views/policy/policy-activities.html';
import PolicyNotesTemplate from 'text!../views/policy/policy-notes.html';
import PolicyDocumentsTemplate from 'text!../views/policy/policy-documents.html';
import PolicyClaimsTemplate from 'text!../views/policy/policy-claims.html';
import PolicyBillingTemplate from 'text!../views/policy/policy-billing.html';
import PolicyContactParentTemplate from 'text!../contacts/common/views/policy-contact-parent.html';
import PolicyContactSummaryTemplate from 'text!../contacts/common/views/policy-contact-summary.html';
import PolicyContactRelatedTemplate from 'text!../contacts/common/views/policy-contact-related.html';
import PolicyContactAccountTemplate from 'text!../contacts/common/views/policy-contact-account.html';
import PolicyContactDetailTemplate from 'text!../contacts/common/views/policy-contact-detail.html';
import PreferencesTemplate from 'text!../views/preferences.html';
import QuoteSummaryTemplate from 'text!../views/quote/quote-summary.html';
import QuoteNotesTemplate from 'text!../views/quote/quote-notes.html';
import QuoteDocumentsTemplate from 'text!../views/quote/quote-documents.html';
import QuoteActivitiesTemplate from 'text!../views/quote/quote-activities.html';
import RenewalSummaryTemplate from 'text!../views/renewal/renewal-summary.html';
import RenewalNotesTemplate from 'text!../views/renewal/renewal-notes.html';
import RenewalDocumentsTemplate from 'text!../views/renewal/renewal-documents.html';
import RenewalActivitiesTemplate from 'text!../views/renewal/renewal-activities.html';
import EndorsementSummaryTemplate from 'text!../views/endorsement/endorsement-summary.html';
import EndorsementNotesTemplate from 'text!../views/endorsement/endorsement-notes.html';
import EndorsementDocumentsTemplate from 'text!../views/endorsement/endorsement-documents.html';
import EndorsementActivitiesTemplate from 'text!../views/endorsement/endorsement-activities.html';
import CancellationSummaryTemplate from 'text!../views/cancellation/cancellation-summary.html';
import CancellationNotesTemplate from 'text!../views/cancellation/cancellation-notes.html';
import CancellationDocumentsTemplate from 'text!../views/cancellation/cancellation-documents.html';
import CancellationActivitiesTemplate from 'text!../views/cancellation/cancellation-activities.html';
import ActivitiesLandingTemplate from 'text!../views/activities-landing.html';
import ReportsTemplate from 'text!../views/gateway-reports.html';
import billingDetailsTemplate from 'text!edge/gateway/views/billing-details.html';
import setupStreamAutopayTemplate from 'text!edge/gateway/views/gateway-setup-stream-autopay.html';
import setupChangePaymentTemplate from 'text!edge/billing/views/setup-change-payment.html';
import changePaymentConfirmationTemplate from 'text!edge/billing/views/setup-changepayment-confirmation.html';
import removePaymentConfirmationTemplate from 'text!edge/billing/views/setup-removepayment-confirmation.html';
import autoPayConfirmationTemplate from 'text!edge/billing/views/setup-autopay-confirmation.html';
import PolicyChangeCtrl from '../controllers/policy/PolicyChangeCtrl';
import PreemptionCtrl from '../controllers/policy/PreemptionCtrl';
import GatewayHomeCtrl from '../controllers/GatewayHomeCtrl';
import NewQuoteAccountSearchCtrl from '../controllers/NewQuoteAccountSearchCtrl';
import NewQuoteCtrl from '../controllers/NewQuoteCtrl';
import AccountDetailCtrl from '../controllers/AccountDetailCtrl';
import SearchCtrl from '../controllers/SearchCtrl';
import PolicyDetailCtrl from '../controllers/PolicyDetailCtrl';
import QuoteDetailCtrl from '../controllers/QuoteDetailCtrl';
import RenewalDetailCtrl from '../controllers/RenewalDetailCtrl';
import EndorsementDetailCtrl from '../controllers/EndorsementDetailCtrl';
import CancellationDetailCtrl from '../controllers/CancellationDetailCtrl';
import AccountLandingCtrl from '../controllers/AccountLandingCtrl';
import ClaimsLandingCtrl from '../controllers/ClaimsLandingCtrl';
import AccountSummaryCtrl from '../controllers/account/AccountSummaryCtrl';
import InvoicePaymentCtrl from 'edge/billing/controllers/InvoicePaymentCtrl';
import AccountActivitiesCtrl from '../controllers/account/ActivitiesCtrl';
import AccountQuotesCtrl from '../controllers/account/QuotesCtrl';
import AccountClaimsCtrl from '../controllers/account/ClaimsCtrl';
import AccountContactsParentCtrl from '../contacts/common/controllers/AccountContactsParentCtrl';
import AccountContactsCtrl from '../contacts/common/controllers/AccountContactsCtrl';
import AccountContactDetailCtrl from '../contacts/common/controllers/AccountContactDetailCtrl';
import JourneyPageCtrl from 'conditional?if=journey&equals=true!edge/journey/controllers/JourneyPageCtrl';
import AccountPolicyTransactionsCtrl from '../controllers/account/PolicyTransactionsCtrl';
import AccountNotesCtrl from '../controllers/account/NotesCtrl';
import AccountDocumentsCtrl from '../controllers/account/DocumentsCtrl';
import AccountBillingCtrl from '../controllers/account/BillingCtrl';
import PolicyLandingCtrl from '../controllers/PolicyLandingCtrl';
import PolicySummaryCtrl from '../controllers/policy/PolicySummaryCtrl';
import PolicyActivitiesCtrl from '../controllers/policy/PolicyActivitiesCtrl';
import PolicyNotesCtrl from '../controllers/policy/PolicyNotesCtrl';
import PolicyDocumentsCtrl from '../controllers/policy/PolicyDocumentsCtrl';
import PolicyClaimsCtrl from '../controllers/policy/PolicyClaimsCtrl';
import PolicyBillingCtrl from '../controllers/policy/PolicyBillingCtrl';
import PolicyContactParentCtrl from '../contacts/common/controllers/PolicyContactParentCtrl';
import PolicyContactSummaryCtrl from '../contacts/common/controllers/PolicyContactSummaryCtrl';
import PolicyContactDetailsCtrl from '../contacts/common/controllers/PolicyContactDetailsCtrl';
import PolicyRelatedAccountContactsCtrl from '../contacts/common/controllers/PolicyRelatedAccountContactsCtrl';
import PolicyContactAccountCtrl from '../contacts/common/controllers/PolicyContactAccountCtrl';
import PreferencesCtrl from '../controllers/PreferencesCtrl';
import QuoteSummaryCtrl from '../controllers/quote/QuoteSummaryCtrl';
import QuoteNotesCtrl from '../controllers/quote/QuoteNotesCtrl';
import QuoteDocumentsCtrl from '../controllers/quote/QuoteDocumentsCtrl';
import QuoteActivitiesCtrl from '../controllers/quote/QuoteActivitiesCtrl';
import RenewalSummaryCtrl from '../controllers/renewal/RenewalSummaryCtrl';
import RenewalNotesCtrl from '../controllers/renewal/RenewalNotesCtrl';
import RenewalDocumentsCtrl from '../controllers/renewal/RenewalDocumentsCtrl';
import RenewalActivitiesCtrl from '../controllers/renewal/RenewalActivitiesCtrl';
import EndorsementSummaryCtrl from '../controllers/endorsement/EndorsementSummaryCtrl';
import EndorsementNotesCtrl from '../controllers/endorsement/EndorsementNotesCtrl';
import EndorsementDocumentsCtrl from '../controllers/endorsement/EndorsementDocumentsCtrl';
import EndorsementActivitiesCtrl from '../controllers/endorsement/EndorsementActivitiesCtrl';
import CancellationSummaryCtrl from '../controllers/cancellation/CancellationSummaryCtrl';
import CancellationNotesCtrl from '../controllers/cancellation/CancellationNotesCtrl';
import CancellationDocumentsCtrl from '../controllers/cancellation/CancellationDocumentsCtrl';
import CancellationActivitiesCtrl from '../controllers/cancellation/CancellationActivitiesCtrl';
import ActivitiesLandingCtrl from '../controllers/ActivitiesLandingCtrl';
import BillingDetailsCtrl from 'edge/gateway/controllers/GatewayBillingDetailsCtrl';
import SetupStreamAutopayCtrl from 'edge/billing/controllers/SetupStreamAutopayCtrl';
import SetupChangePaymentCtrl from 'edge/billing/controllers/SetupChangePaymentCtrl';
import SetupAutoPayConfirmationCtrl from 'edge/billing/controllers/SetupAutoPayConfirmationCtrl';
import ChangePaymentConfirmationCtrl from 'edge/billing/controllers/ChangePaymentConfirmationCtrl';
import RemovePaymentConfirmationCtrl from 'edge/billing/controllers/RemovePaymentConfirmationCtrl';
import GatewayReportsController from '../controllers/GatewayReportsController';
import ReinstatementDetailCtrl from 'edge/gateway/controllers/ReinstatementDetailCtrl';
import ReinstatementDetailTemplate from 'text!edge/gateway/directives/reinstatement-detail.html';
import ReinstatementSummaryCtrl from 'edge/gateway/controllers/ReinstatementSummaryCtrl';
import ReinstatementSummaryTemplate from 'text!edge/gateway/directives/reinstatement-summary.html';
import GatewayContactUsTemplate from 'text!../views/gateway-contact-us.html';
import GatewayContactUsCtrl from '../controllers/GatewayContactUsCtrl';
//For GPA Payroll
import PayrollDetailTemplate from 'text!edge/gateway/views/payroll-details.html';
import PayrollDetailCtrl from 'edge/gateway/controllers/PayrollDetailsCtrl';
//For GPA Upload Application
import UploadApplicationTemplate from 'text!edge/gateway/views/upload-application.html';
import UploadApplicationCtrl from 'edge/gateway/controllers/UploadApplicationCtrl';
//For Construction Credit
import ConstructionCreditTemplate from 'text!edge/gateway/views/construction-credit.html';
import ConstructionCreditCtrl from 'edge/gateway/controllers/ConstructionCreditCtrl';
//For GPA Payroll Enter Payroll
import EnterPayrollDetailTemplate from 'text!edge/gateway/views/enterpayroll-details.html';
import EnterPayrollDetailCtrl from 'edge/gateway/controllers/EnterPayrollDetailsCtrl';
//For AMP Payroll Edit Payroll
import EditPayrollDetailTemplate from 'text!edge/gateway/views/editpayroll-details.html';
import EditPayrollDetailCtrl from 'edge/gateway/controllers/EditPayrollDetailsCtrl';
//Payroll submit
import PayrollSubmitTemplate from 'text!edge/gateway/views/payroll-submit.html';
import PayrollSubmitCtrl from 'edge/gateway/controllers/PayrollSubmitCtrl';

export default (function (RootStates, isProducer) {
    var parentState = RootStates.main_root;
    var billingState = 'billing-';

    var commonRoutes = {
        gatewayLanding: {
            name: 'gatewayLanding',
            parent: parentState,
            url: '/home',
            controller: GatewayHomeCtrl,
            template: GatewayHomeTemplate,
            data: {
                errorMsg: null,
                actions: {
                    next: 'newQuoteSearch'
                }
            }
        },
        newQuote: {
            name: 'newQuote',
            url: '/new-quote/{accountNumber}/{searchResult}',
            parent: parentState,
            template: NewQuoteTemplate,
            controller: NewQuoteCtrl,
            data: {
                actions: {
                    next: 'gatewayLanding'
                }
            }
        },
        //*** Payroll Reporting ***//
        'payroll-details': {
            name: 'payroll-details',
            url: '/payroll-details/{policyNumber}',
            parent: parentState,
            controller: PayrollDetailCtrl,
            template: PayrollDetailTemplate
        },
        //*** Upload Application ***//
        'upload-application': {
            name: 'upload-application',
            url: '/upload-application/',
            parent: parentState,
            controller: UploadApplicationCtrl,
            template: UploadApplicationTemplate
        },
        //*** Construction Credit***//
        'ConstructionCredit': {
            name: 'construction-credit',
            url: '/construction-credit/:policyNumber/:jobNumber',
            parent: parentState,
            controller: ConstructionCreditCtrl,
            template: ConstructionCreditTemplate,
            params: {
                policyNumber: "policyNumber",
                jobNumber: "jobNumber"
            }
        },

        //*** Payroll Reporting Enter payroll ***//
        'enterpayroll-details': {
            name: 'enterpayroll-details',
            url: '/enterpayroll-details/{jobNumber}/{startDate}/{endDate}',
            parent: parentState,
            controller: EnterPayrollDetailCtrl,
            template: EnterPayrollDetailTemplate
        },
        'editpayroll-details': {
            name: 'editpayroll-details',
            url: '/editpayroll-details/{jobNumber}/{startDate}/{endDate}/{viewOnly}',
            parent: parentState,
            controller: EditPayrollDetailCtrl,
            template: EditPayrollDetailTemplate

        },
        //*** Payroll Submit ***//
        'payroll-submit': {
            name: 'payroll-submit',
            url: '/payroll-submit/{jobNumber}',
            parent: parentState,
            controller: PayrollSubmitCtrl,
            template: PayrollSubmitTemplate
        },

        newPolicyChange: {
            name: 'newPolicyChange',
            parent: parentState,
            url: '/new-policy/:policyNumber/:data/:jobNumber/:effDate/:accountName/:status',
            template: PolicyChangeTemplate,
            controller: PolicyChangeCtrl,
            params: {
                policyNumber: "policyNumber",
                data: "data",
                jobNumber: "jobNumber",
                accountName: "msfAccountName",
                effDate: "effDate",
                status: "status"
            }

        },
        preemption: {
            name: 'preemption',
            parent: parentState,
            url: '/preemption/',
            template: PreemptionTemplate,
            controller: PreemptionCtrl,
            params: {
                policyNumber: "policyNumber",
                data: "data",
                jobNumber: "jobNumber",
                accountName: "msfAccountName",
                effDate: "effDate"
            }

        },
        newQuoteSearch: {
            name: 'newQuoteSearch',
            parent: parentState,
            url: '/new-quote-account-search/',
            template: NewQuoteAccountSearchTemplate,
            controller: NewQuoteAccountSearchCtrl,
            data: {
                actions: {
                    next: 'newQuote'
                }
            }
        },
        ContactUsHome: {
            name: 'ContactUsHome',
            parent: parentState,
            url: '/contact-us',
            template: GatewayContactUsTemplate,
            controller: GatewayContactUsCtrl,
            data: {
                actions: {
                    next: 'ContactUs'
                }
            }
        },

        viewSearch: {
            name: 'viewSearch',
            parent: parentState,
            url: '/search/{searchParam}',
            template: SearchTemplate,
            controller: SearchCtrl,
            data: {
                label: 'Search',
                actions: {}
            }
        },

        viewSearch1: {
            name: 'viewSearch1',
            parent: parentState,
            url: '/search/{searchParam}',
            template: SearchTemplate,
            controller: GatewayHomeCtrl,
            data: {
                label: 'Search',
                actions: {}
            }
        },

        // **** BEGIN - Accounts ****
        accountParent: {
            abstract: true,
            name: 'accounts',
            parent: parentState,
            url: '/accounts',
            template: '<ui-view/>'
        },

        viewAccount: {
            abstract: true,
            name: 'accounts.detail',
            url: '/{accountNumber}',
            template: AccountDetailTemplate,
            controller: AccountDetailCtrl,
            data: {
                label: 'View Account',
                actions: {}
            }
        },
        accountSummary: {
            name: 'accounts.detail.summary',
            url: '/summary',
            template: AccountSummaryTemplate,
            controller: AccountSummaryCtrl,
            data: {
                label: 'View Account',
                actions: {}
            }
        },

        accountActivities: {
            name: 'accounts.detail.activities',
            url: '/activities',
            template: AccountActivitiesTemplate,
            controller: AccountActivitiesCtrl,
            data: {
                label: 'Activities',
                actions: {}
            }
        },

        accountQuotes: {
            name: 'accounts.detail.quotes',
            url: '/quotes',
            template: AccountQuotesTemplate,
            controller: AccountQuotesCtrl,
            data: {
                label: 'Quotes',
                actions: {}
            }
        },

        accountClaims: {
            name: 'accounts.detail.claims',
            url: '/claims',
            template: AccountClaimsTemplate,
            controller: AccountClaimsCtrl,
            data: {
                label: 'Claims',
                actions: {}
            }
        },

        accountContactsParent: {
            redirectTo: 'accounts.detail.contacts.accountContacts',
            name: 'accounts.detail.contacts',
            url: '/contacts',
            template: AccountContactsParentTemplate,
            controller: AccountContactsParentCtrl,
            controllerAs: '$ctrl'
        },

        accountContacts: {
            name: 'accounts.detail.contacts.accountContacts',
            template: AccountContactsTemplate,
            controller: AccountContactsCtrl,
            controllerAs: '$ctrl',
            url: '/account',
            data: {
                label: 'Account Contacts',
                action: {}
            }
        },

        relatedContacts: {
            name: 'accounts.detail.contacts.relatedContacts',
            template: RelatedAccountContactsTemplate,
            controller: AccountContactsCtrl,
            controllerAs: '$ctrl',
            url: '/related',
            data: {
                label: 'Related Contacts',
                action: {}
            }
        },

        accountContactDetail: {
            name: 'accounts.detail.accountContactDetail',
            url: '/contacts/account',
            template: AccountContactDetailTemplate,
            controller: AccountContactDetailCtrl,
            controllerAs: '$ctrl',
            data: {
                sourceState: 'accounts.detail.contacts.accountContacts'
            }
        },

        relatedContactDetail: {
            name: 'accounts.detail.relatedContactDetail',
            url: '/contacts/related/{contactNumber}',
            template: AccountContactDetailTemplate,
            controller: AccountContactDetailCtrl,
            controllerAs: '$ctrl',
            data: {
                sourceState: 'accounts.detail.contacts.relatedContacts'
            }
        },

        accountPolicyTransactions: {
            name: 'accounts.detail.policy-transactions',
            url: '/work-orders',
            template: AccountPolicyTransactionsTemplate,
            controller: AccountPolicyTransactionsCtrl,
            data: {
                label: 'Claims',
                actions: {}
            }
        },

        accountNotes: {
            name: 'accounts.detail.notes',
            url: '/notes',
            template: AccountNotesTemplate,
            controller: AccountNotesCtrl,
            data: {
                label: 'Notes',
                actions: {}
            }
        },

        accountDocuments: {
            name: 'accounts.detail.documents',
            url: '/documents',
            template: AccountDocumentsTemplate,
            controller: AccountDocumentsCtrl,
            data: {
                label: 'Documents',
                actions: {}
            }
        },

        accountBilling: {
            name: 'accounts.detail.billing',
            url: '/billing',
            template: AccountBillingTemplate,
            controller: AccountBillingCtrl,
            data: {
                label: 'Billing',
                actions: {}
            }
        },
        // **** END - Accounts ****


        // **** START - Policies ****
        policyContactsParent: {
            redirectTo: 'policies.detail.contacts.policy',
            name: 'policies.detail.contacts',
            url: '/contacts',
            template: PolicyContactParentTemplate,
            controller: PolicyContactParentCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Contacts',
                action: {}
            }
        },

        policyContacts: {
            name: 'policies.detail.contacts.policy',
            url: '/policy',
            template: PolicyContactSummaryTemplate,
            controller: PolicyContactSummaryCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Contacts',
                action: {}
            }
        },

        policyAccountContacts: {
            name: 'policies.detail.contacts.account',
            url: '/account',
            template: PolicyContactAccountTemplate,
            controller: PolicyContactAccountCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Account Contacts',
                action: {}
            }
        },

        policyRelatedContacts: {
            name: 'policies.detail.contacts.related',
            url: '/related',
            template: PolicyContactRelatedTemplate,
            controller: PolicyRelatedAccountContactsCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Associated Contacts',
                action: {}
            }
        },

        policyAccountContactDetail: {
            name: 'policies.detail.account-contact-detail',
            url: '/account-contact/{contactNumber}',
            template: AccountContactDetailTemplate,
            controller: AccountContactDetailCtrl,
            controllerAs: '$ctrl',
            data: {
                sourceState: 'policies.detail.contacts.account'
            }
        },

        policyAssociatedContactDetail: {
            name: 'policies.detail.associated-contact-detail',
            url: '/associated-contact/{contactNumber}',
            template: AccountContactDetailTemplate,
            controller: AccountContactDetailCtrl,
            controllerAs: '$ctrl',
            data: {
                sourceState: 'policies.detail.contacts.related'
            }
        },

        policyContactDetail: {
            name: 'policies.detail.contact-detail',
            url: '/policy-contact',
            template: PolicyContactDetailTemplate,
            controller: PolicyContactDetailsCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Contacts',
                action: {}
            }

        },

        policyParent: {
            abstract: true,
            name: 'policies',
            parent: parentState,
            url: '/policies',
            template: '<ui-view/>'
        },

        viewPolicy: {
            abstract: true,
            name: 'policies.detail',
            url: '/{policyNumber}',
            template: PolicyDetailTemplate,
            controller: PolicyDetailCtrl,
            data: {
                label: 'View Policy',
                actions: {}
            }
        },

        policySummary: {
            name: 'policies.detail.summary',
            url: '/summary',
            template: PolicySummaryTemplate,
            controller: PolicySummaryCtrl,
            data: {
                label: 'View Policy',
                actions: {}
            }
        },

        policyActivities: {
            name: 'policies.detail.activities',
            url: '/activities',
            template: PolicyActivitiesTemplate,
            controller: PolicyActivitiesCtrl,
            data: {
                label: 'View Policy',
                actions: {}
            }
        },

        policyNotes: {
            name: 'policies.detail.notes',
            url: '/notes',
            template: PolicyNotesTemplate,
            controller: PolicyNotesCtrl,
            data: {
                label: 'View Policy Notes',
                actions: {}
            }
        },

        policyDocuments: {
            name: 'policies.detail.documents',
            url: '/documents',
            template: PolicyDocumentsTemplate,
            controller: PolicyDocumentsCtrl,
            data: {
                label: 'View Policy Documents',
                actions: {}
            }
        },

        policyClaims: {
            name: 'policies.detail.claims',
            url: '/claims',
            template: PolicyClaimsTemplate,
            controller: PolicyClaimsCtrl,
            data: {
                label: 'View Policy Claims',
                actions: {}
            }
        },
        policyBilling: {
            name: 'policies.detail.billing',
            url: '/billing',
            template: PolicyBillingTemplate,
            controller: PolicyBillingCtrl,
            data: {
                label: 'View Policy Billing',
                actions: {}
            }
        },
        // **** END - Policies ****


        // **** START - QUOTES ****
        quoteParent: {
            abstract: true,
            name: 'quote',
            parent: parentState,
            url: '/quotes',
            template: '<ui-view/>'
        },

        viewQuote: {
            name: 'quote.detail',
            abstract: true,
            url: '/{submissionNumber}',
            template: QuoteDetailTemplate,
            controller: QuoteDetailCtrl,
            data: {
                label: 'View Quote',
                actions: {}
            }
        },

        quoteSummary: {
            name: 'quote.detail.summary',
            url: '/summary',
            template: QuoteSummaryTemplate,
            controller: QuoteSummaryCtrl,
            data: {
                label: 'View Quote Summary',
                actions: {}
            }
        },

        quoteActivities: {
            name: 'quote.detail.activities',
            url: '/activities',
            template: QuoteActivitiesTemplate,
            controller: QuoteActivitiesCtrl,
            data: {
                label: 'View Quote Activities',
                actions: {}
            }
        },
        quoteNotes: {
            name: 'quote.detail.notes',
            url: '/notes',
            template: QuoteNotesTemplate,
            controller: QuoteNotesCtrl,
            data: {
                label: 'View Quote Notes',
                actions: {}
            }
        },

        quoteDocuments: {
            name: 'quote.detail.documents',
            url: '/documents',
            template: QuoteDocumentsTemplate,
            controller: QuoteDocumentsCtrl,
            data: {
                label: 'View Quote Notes',
                actions: {}
            }
        },
        // **** END - QUOTES ****

        // **** START - RENEWAL ****
        renewalParent: {
            abstract: true,
            name: 'renewal',
            parent: parentState,
            url: '/renewals',
            template: '<ui-view/>'
        },

        viewRenewal: {
            name: 'renewal.detail',
            abstract: true,
            url: '/{renewalNumber}',
            template: RenewalDetailTemplate,
            controller: RenewalDetailCtrl,
            data: {
                label: 'View Renewal',
                actions: {}
            }
        },

        renewalSummary: {
            name: 'renewal.detail.summary',
            url: '/summary',
            template: RenewalSummaryTemplate,
            controller: RenewalSummaryCtrl,
            data: {
                label: 'View Renewal Summary',
                actions: {}
            }
        },

        renewalActivities: {
            name: 'renewal.detail.activities',
            url: '/activities',
            template: RenewalActivitiesTemplate,
            controller: RenewalActivitiesCtrl,
            data: {
                label: 'View Renewal Activities',
                actions: {}
            }
        },

        renewalNotes: {
            name: 'renewal.detail.notes',
            url: '/notes',
            template: RenewalNotesTemplate,
            controller: RenewalNotesCtrl,
            data: {
                label: 'View Renewal Notes',
                actions: {}
            }
        },

        renewalDocuments: {
            name: 'renewal.detail.documents',
            url: '/documents',
            template: RenewalDocumentsTemplate,
            controller: RenewalDocumentsCtrl,
            data: {
                label: 'View Renewal Notes',
                actions: {}
            }
        },
        // **** END - RENEWAL ****

        // **** START - ENDORSEMENTS ****
        endorsementParent: {
            abstract: true,
            name: 'endorsements',
            parent: parentState,
            url: '/endorsements',
            template: '<ui-view/>'
        },

        viewEndorsement: {
            name: 'endorsements.detail',
            abstract: true,
            url: '/{policyChangeNumber}',
            template: EndorsementDetailTemplate,
            controller: EndorsementDetailCtrl,
            data: {
                label: 'View Endorsement',
                actions: {}
            }
        },

        endorsementSummary: {
            name: 'endorsements.detail.summary',
            url: '/summary',
            template: EndorsementSummaryTemplate,
            controller: EndorsementSummaryCtrl,
            data: {
                label: 'View Endorsement Summary',
                actions: {}
            }
        },

        endorsementSummaryActivities: {
            name: 'endorsements.detail.activities',
            url: '/activities',
            template: EndorsementActivitiesTemplate,
            controller: EndorsementActivitiesCtrl,
            data: {
                label: 'View Endorsement Activities',
                actions: {}
            }
        },

        endorsementSummaryNotes: {
            name: 'endorsements.detail.notes',
            url: '/notes',
            template: EndorsementNotesTemplate,
            controller: EndorsementNotesCtrl,
            data: {
                label: 'View Endorsement Notes',
                actions: {}
            }
        },

        endorsementSummaryDocuments: {
            name: 'endorsements.detail.documents',
            url: '/documents',
            template: EndorsementDocumentsTemplate,
            controller: EndorsementDocumentsCtrl,
            data: {
                label: 'View Endorsement Notes',
                actions: {}
            }
        },
        // **** END - ENDORSEMENTS ****


        // **** START - CANCELLATIONS ****
        cancellationParent: {
            abstract: true,
            name: 'cancellation',
            parent: parentState,
            url: '/cancellation',
            template: '<ui-view/>'
        },

        viewCancellation: {
            name: 'cancellation.detail',
            abstract: true,
            url: '/{cancellationNumber}',
            template: CancellationDetailTemplate,
            controller: CancellationDetailCtrl,
            data: {
                label: 'View Cancellation',
                actions: {}
            }
        },

        cancellationSummary: {
            name: 'cancellation.detail.summary',
            url: '/summary',
            template: CancellationSummaryTemplate,
            controller: CancellationSummaryCtrl,
            data: {
                label: 'View Cancellation Summary',
                actions: {}
            }
        },

        cancellationSummaryActivities: {
            name: 'cancellation.detail.activities',
            url: '/activities',
            template: CancellationActivitiesTemplate,
            controller: CancellationActivitiesCtrl,
            data: {
                label: 'View Cancellation Activities',
                actions: {}
            }
        },

        cancellationSummaryNotes: {
            name: 'cancellation.detail.notes',
            url: '/notes',
            template: CancellationNotesTemplate,
            controller: CancellationNotesCtrl,
            data: {
                label: 'View Cancellation Notes',
                actions: {}
            }
        },

        cancellationSummaryDocuments: {
            name: 'cancellation.detail.documents',
            url: '/documents',
            template: CancellationDocumentsTemplate,
            controller: CancellationDocumentsCtrl,
            data: {
                label: 'View Cancellation Notes',
                actions: {}
            }
        },
        // **** END - CANCELLATIONS ****


        // **** START - Activities ****
        activityParent: {
            abstract: true,
            name: 'activities',
            parent: parentState,
            url: '/activities',
            template: '<ui-view/>'
        },

        activitiesLanding: {
            name: 'activities.index',
            url: '/',
            template: ActivitiesLandingTemplate,
            controller: ActivitiesLandingCtrl,
            data: {
                label: 'Activities',
                actions: {}
            }
        },
        // **** END - Activities ****

        reinstatementParent: {
            abstract: true,
            name: 'reinstatement',
            parent: parentState,
            url: '/reinstatement',
            template: '<ui-view/>'
        },

        viewReinstatement: {
            name: 'reinstatement.detail',
            abstract: true,
            url: '/{reinstatementNumber}',
            template: ReinstatementDetailTemplate,
            controller: ReinstatementDetailCtrl,
            data: {
                label: 'View Reinstatement',
                actions: {}
            }
        },

        reinstatementSummary: {
            name: 'reinstatement.detail.summary',
            url: '/summary',
            template: ReinstatementSummaryTemplate,
            controller: ReinstatementSummaryCtrl,
            data: {
                label: 'View Reinstatement Summary',
                actions: {}
            }
        },

        // **** START - Billing ****
        'gatewaybilling-invoice-payment': {
            name: 'gateway' + billingState + 'invoice-payment',
            url: '/pay-invoices/{payMode}/{accountNumber}',
            parent: parentState,
            template: InvoicePaymentTemplate,
            controller: InvoicePaymentCtrl,
            data: {
                actions: {}
            }
        },

        'agentbilling-summary': {
            name: 'accounts.detail.payment',
            url: '/payments',
            abstract: 'true',
            template: '<ui-view/>'
        },

        'gatewaybilling-payments': {
            name: 'accounts.detail.payment.index',
            url: '',
            controller: BillingDetailsCtrl,
            template: billingDetailsTemplate
        },

        'gatewaybilling-setup-group-autopay': {
            name: 'accounts.detail.payment.setup-autopay',
            url: '/setup-group-autopay/{streamId}',
            template: setupStreamAutopayTemplate,
            controller: SetupStreamAutopayCtrl,
            data: {
                actions: {
                    setupAutoPay: 'accounts.detail.payment.setup-autopay-confirmation'
                }
            }
        },
        /**
         * Routing for Change Payment 
         */
        'gatewaybilling-setup-change-payment': {
            name: 'accounts.detail.payment.setup-changepayment',
            url: '/setup-change-payment/{streamId}',
            template: setupChangePaymentTemplate,
            controller: SetupChangePaymentCtrl,
            data: {
                actions: {}
            }
        },
        /**
         * Change Payment Confirmation
         */
        'gatewaybilling-changepayment-confirmation': {
            name: 'accounts.detail.payment.setup-changepayment-confirmation',
            url: '/changepayment-confirmation',
            template: changePaymentConfirmationTemplate,
            controller: ChangePaymentConfirmationCtrl,
            data: {
                actions: {
                    actions: {
                        cancel: 'accounts.detail.payment.index'
                    }
                }
            }
        },
        /**
         * Remove Payment Confirmation
         */
        'gatewaybilling-removepayment-confirmation': {
            name: 'accounts.detail.payment.setup-removepayment-confirmation',
            url: '/removepayment-confirmation',
            template: removePaymentConfirmationTemplate,
            controller: RemovePaymentConfirmationCtrl,
            data: {
                actions: {
                    actions: {
                        cancel: 'accounts.detail.payment.index'
                    }
                }
            }
        },

        'agentbilling-setup-autopay-confirmation': {
            name: 'accounts.detail.payment.setup-autopay-confirmation',
            url: '/setup-autopay-confirmation',
            template: autoPayConfirmationTemplate,
            controller: SetupAutoPayConfirmationCtrl,
            data: {
                actions: {
                    actions: {
                        cancel: 'accounts.detail.payment.index'
                    }
                }
            },
            params: {
                info: {
                    value: null
                }
            }
        },
        // **** END - Billing ****


        'preferences': {
            name: 'preferences',
            url: '/preferences',
            parent: parentState,
            template: PreferencesTemplate,
            controller: PreferencesCtrl,
            data: {
                actions: {}
            }
        }
    };

    var agentRoutes = {
        // **** BEGIN - Accounts ****
        accountLanding: {
            name: 'accounts.index',
            url: '',
            template: AccountLandingTemplate,
            controller: AccountLandingCtrl,
            data: {
                label: 'Accounts',
                actions: {}
            }
        },
        // **** END - Accounts ****


        // **** START - Policies ****
        policyLanding: {
            name: 'policies.index',
            url: '/?quickFilter',
            template: PolicyLandingTemplate,
            controller: PolicyLandingCtrl,
            data: {
                label: 'Policies',
                actions: {}
            }
        },
        // **** END - Policies ****


        claimsLanding: {
            name: 'claims',
            url: '/claims',
            parent: parentState,
            template: ClaimsLandingTemplate,
            controller: ClaimsLandingCtrl,
            data: {
                label: 'Claims',
                actions: {}
            }
        },

        reportsLanding: {
            name: 'reports',
            url: '/analytics',
            parent: parentState,
            template: ReportsTemplate,
            controller: GatewayReportsController
        }
    };

    if (ApplicationFeatures.hasFeature('journey')) {
        commonRoutes.accountJourney = {
            name: 'accounts.detail.journey',
            url: '/journey/timeline',
            template: JourneyPageTemplate,
            controller: JourneyPageCtrl,
            controllerAs: '$ctrl',
            data: {
                label: 'Journey',
                action: {}
            }
        };
    }

    if (!isProducer) {
        return commonRoutes;
    }

    return angular.extend({}, commonRoutes, agentRoutes);
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/config/RouteConfig.js
// module id = 1609
// module chunks = 0